import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

// Single-image picker: file upload (object storage) OR direct URL. Shows a preview.
export default function ImageUpload({ value, onChange, testid, label }) {
    const fileRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const upload = async (files) => {
        const file = files?.[0];
        if (!file) return;
        setUploading(true);
        try {
            const fd = new FormData();
            fd.append("file", file);
            const { data } = await api.post("/uploads/images", fd, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            onChange(data.url);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setUploading(false);
            if (fileRef.current) fileRef.current.value = "";
        }
    };

    return (
        <div data-testid={testid}>
            <input
                ref={fileRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => upload(e.target.files)}
                data-testid={`${testid}-file`}
            />
            {value ? (
                <div className="flex items-start gap-4 mb-3">
                    <img
                        src={value}
                        alt=""
                        className="h-20 w-20 object-contain bg-white border border-gray-200 p-1"
                        data-testid={`${testid}-preview`}
                    />
                    <button
                        type="button"
                        onClick={() => onChange("")}
                        data-testid={`${testid}-remove`}
                        className="inline-flex items-center gap-1.5 px-3 py-2 bg-red-50 text-red-600 hover:bg-red-100 text-[0.66rem] tracking-[0.16em] uppercase font-semibold"
                    >
                        <X className="w-3.5 h-3.5" /> {label || "Retirer"}
                    </button>
                </div>
            ) : null}
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={() => fileRef.current?.click()}
                    disabled={uploading}
                    data-testid={`${testid}-btn`}
                    className="inline-flex items-center gap-2 px-5 py-3 bg-brand-gold hover:bg-brand-gold-deep disabled:opacity-60 text-white text-[0.7rem] tracking-[0.2em] uppercase font-semibold transition-colors"
                >
                    <Upload className="w-4 h-4" /> {uploading ? "…" : (label || "Envoyer une image")}
                </button>
                <input
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder="https://..."
                    data-testid={`${testid}-url`}
                    className="flex-1 border border-gray-200 px-4 py-2.5 text-sm focus:outline-none focus:border-brand-gold"
                />
            </div>
        </div>
    );
}
